import { Tooltip } from '@chakra-ui/react';
import * as React from 'react';

import { SubtleSwitch } from '@/imports/ui/chakra/components/SubtleSwitch';
import { InfoIcon } from '@/imports/ui/chakra/feather';

export type ICsvImportAccountCreationConfigurationProps = {
  shouldCreateAccounts: boolean;
  setShouldCreateAccounts: (value: boolean) => void;
};

export const CsvImportAccountCreationConfiguration: React.FC<
  ICsvImportAccountCreationConfigurationProps
> = ({ shouldCreateAccounts, setShouldCreateAccounts }) => {
  return (
    <SubtleSwitch
      isChecked={shouldCreateAccounts}
      onChange={(event) => setShouldCreateAccounts(event.target.checked)}
    >
      Create new accounts for records that do not match an existing Tradewing
      account
      <Tooltip label="This can be helpful when importing users who may not have Tradewing accounts yet.">
        <InfoIcon color="gray.500" ml="2" />
      </Tooltip>
    </SubtleSwitch>
  );
};
